module.exports = __webpack_public_path__ + "9ab62bf490e3d9e05437549afe075064.png";